import { useMemo } from 'react';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import trackLogoCardIsHovered from '../../../bi/bigQuery/logoCardIsHovered';
import trackLogoProjectCardClick from '../../../bi/bigQuery/logoProjectCardClick';
import trackLogoVariationFromGalleryClick from '../../../bi/bigQuery/logoVariationFromGalleryClick';
import trackLogoMakerBuyerListingShow from '../../../bi/bigQuery/logoMakerBuyerListingShow';
import useImpressionObserver from '../../../../../hooks/useImpressionObserver';
import { transformProjectToLogoEnrichment } from '../../../bi/utils';

const { reportLogoVariationHover, reportLogoClicked, reportLogoHover } =
    marketplaceIntegration;

const useListingTracking = ({ projects = [], briefId, containerRef }) => {
    const projectsMap = useMemo(
        () =>
            projects.reduce((res, project) => {
                res[project.id] = project;
                return res;
            }, {}),
        [projects]
    );

    const trackingHandlers = {
        onLogoProjectVariationHover: (cardDetails) => {
            const bqHandler = trackLogoCardIsHovered({ projectsMap, briefId });

            bqHandler(cardDetails);
            reportLogoVariationHover(
                transformProjectToLogoEnrichment(cardDetails)
            );
        },

        onLogoProjectCardClick: (cardDetails) => {
            const bqHandler = trackLogoProjectCardClick(briefId);
            bqHandler(cardDetails);

            reportLogoClicked(transformProjectToLogoEnrichment(cardDetails));
        },

        onLogoProjectHover: (cardDetails) =>
            reportLogoHover(transformProjectToLogoEnrichment(cardDetails)),

        onLogoProjectArrowClick: trackLogoVariationFromGalleryClick({
            projectsMap,
            briefId,
        }),
    };

    useImpressionObserver(containerRef, trackLogoMakerBuyerListingShow);

    return trackingHandlers;
};

export default useListingTracking;
